import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import InputDropdown from '../../../../../../components/Inputs/Dropdown';
import YearRange from '../../../../../../components/Inputs/YearRange/YearRange';
import { ResultsInputsHookState } from '../useResultsInputs';
import { tpPliList } from './TpPliValues';

interface OwnProps {
  resultsInputs: ResultsInputsHookState;
}

const ResultsInput: React.FC<OwnProps> = ({ resultsInputs }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const {
    profitLevelIndicator,
    indicatorType,
    yearRange,
    adjustments,
    handleTpPliValueChange,
    handleIndicatorTypeValueChange,
    handleYearRangeValueChange,
  } = resultsInputs;

  let pliChangeConfirmation;
  let pliChangeConfirmationTitle;
  if (adjustments?.length !== 0) {
    pliChangeConfirmation = 'benchmark:benchmarkResults.adjustments.adjustmentsResetConfirmation';
    pliChangeConfirmationTitle =
      'benchmark:benchmarkResults.adjustments.adjustmentsResetConfirmationTitle';
  }

  return (
    <>
      <InputDropdown
        label={t('benchmark:benchmarkResults.input.chooseTpPli')}
        className={clsx(styles.dropdown, styles.control)}
        defaultValue={[profitLevelIndicator]}
        confirmationText={pliChangeConfirmation}
        confirmationTitle={pliChangeConfirmationTitle}
        options={tpPliList}
        onChange={handleTpPliValueChange}
      />

      <FormControl component="fieldset" className={clsx(styles.yearRange, styles.control)}>
        <FormLabel className={styles.yearLabel}>
          {t('benchmark:benchmarkResults.input.yearRange')}
        </FormLabel>
        <YearRange
          root={true}
          field={'benchmarkResultsYearRange'}
          defaultValue={yearRange}
          onChange={handleYearRangeValueChange}
        />
      </FormControl>

      <FormControl component="fieldset" className={styles.control}>
        <FormLabel>{t('benchmark:benchmarkResults.input.indicatorType')}</FormLabel>
        <RadioGroup
          row
          aria-label="indicatorType"
          name="indicatorTypeRadioGroup"
          value={indicatorType}
          onChange={handleIndicatorTypeValueChange}
        >
          <FormControlLabel
            value="WEIGHTED"
            control={<Radio size="small" color="primary" />}
            label={t('benchmark:benchmarkResults.input.indicatorTypeWeighted')}
          />
          <FormControlLabel
            value="POOLED"
            control={<Radio size="small" color="primary" />}
            label={t('benchmark:benchmarkResults.input.indicatorTypePooled')}
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  dropdown: {
    width: '100%',
    '& .MuiInputBase-input': {
      minHeight: '18px',
      height: '18px',
    },
    '& .MuiInputBase-root': {
      minHeight: '42px',
    },
    '& label': {
      paddingBottom: theme.spacing(4),
    },
  },

  control: {
    padding: '12px',
  },

  yearLabel: {
    marginBottom: -1 * theme.spacing(3),
  },

  yearRange: {
    marginTop: '10px',
  },
}));

export default ResultsInput;
